//src/admin/pages/AdminAbandonedCartDetails.js
import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { FaInbox, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { getAdminAbandonedCartByUserId } from "../../services/adminAbandonedCarts.api";
import {
  sendAbandonedCartEmail,
} from "../../services/adminAbandonedCarts.api";
import { adminApiRequest } from "../../services/adminApi";
import { FiChevronRight } from "react-icons/fi";
import { FiAlertTriangle, FiCheck, FiCopy, FiShoppingCart, FiX } from "react-icons/fi";
import { getAdminShippingSettings } from "../../services/adminShippingSettings.api";

function AdminAbandonedCartDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { lang } = useContext(AdminLanguageContext);

  const [copied, setCopied] = useState(false);

  const [loading, setLoading] = useState(true);

  const [isOpen, setIsOpen] = useState(false);
  const [cart, setCart] = useState(null);

  const [shippingFee, setShippingFee] = useState(0);
  const [shippingSettings, setShippingSettings] = useState(null);

  const [sending, setSending] = useState(null);

  const t = (en, ar) => (lang === "AR" ? ar : en);


useEffect(() => {
  setLoading(true);

  getAdminAbandonedCartByUserId(id)
    .then((data) => {
      if (!data || !Array.isArray(data.cartItems) || data.cartItems.length === 0) {
        setCart(null);
      } else {
        setCart(data);
      }
    })
    .catch(() => {
      navigate("/admin/abandoned-carts");
    })
    .finally(() => {
      setLoading(false);
    });
}, [id, navigate]);


useEffect(() => {
  getAdminShippingSettings().then(setShippingSettings);
}, []);

  const total =
  cart?.cartItems?.reduce(
    (sum, it) => sum + (it.price || 0) * it.qty,
    0
  ) || 0;

  useEffect(() => {
  if (!shippingSettings) return;

  if (
    shippingSettings.free_enabled &&
    total >= shippingSettings.free_threshold
  ) {
    setShippingFee(0);
  } else {
    setShippingFee(Number(shippingSettings.default_fee || 0));
  }
}, [total, shippingSettings]);


  const handleSendEmail = async () => {
  if (!cart?.email) return;

  try {
    setSending("email");

    await sendAbandonedCartEmail(cart.userId);

    setCart(prev => ({
      ...prev,
      emailSent: true,
    }));
  } finally {
    setSending(null);
  }
};

const handleSendWhatsApp = async () => {
  if (!cart?.phone) return;

  const phone = cart.phone.replace(/\D/g, "");
  const msg = encodeURIComponent(
  lang === "AR"
    ? `مرحباً ${cart.name}، لقد تركت منتجات في سلتك: ${cart.cartLink}`
    : `Hi ${cart.name}, you left items in your cart: ${cart.cartLink}`
);

  window.open(`https://wa.me/${phone}?text=${msg}`, "_blank");

  await adminApiRequest(`/admin/abandoned-carts/${cart.userId}/whatsapp-sent`, {
    method: "POST",
  });

  setCart(prev => ({
    ...prev,
    whatsappSent: true,
  }));
};

const AbandonedCartSkeleton = () => (
  <div className="p-4 sm:p-6 animate-pulse">
    <div className="max-w-[1040px] mx-auto space-y-4">

      {/* HEADER */}
      <div className="h-6 w-48 bg-gray-200 rounded"></div>
      <div className="h-4 w-32 bg-gray-200 rounded"></div>

      {/* BANNER */}
      <div className="h-12 bg-gray-200 rounded-xl"></div>

      {/* MAIN GRID */}
      <div className="grid grid-cols-1 xl:grid-cols-[1fr_320px] gap-4">

        {/* LEFT */}
        <div className="bg-white border rounded-xl p-4 space-y-4">
          <div className="h-4 w-40 bg-gray-200 rounded"></div>

          {[1,2,3].map(i => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gray-200 rounded"></div>
              <div className="flex-1 space-y-2">
                <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
                <div className="h-3 w-1/3 bg-gray-200 rounded"></div>
              </div>
              <div className="w-16 h-3 bg-gray-200 rounded"></div>
            </div>
          ))}

          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
        </div>

        {/* RIGHT */}
        <div className="bg-white border rounded-xl p-4 space-y-4">
          <div className="h-4 w-32 bg-gray-200 rounded"></div>

          <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
          <div className="h-3 w-1/2 bg-gray-200 rounded"></div>

          <div className="h-3 w-full bg-gray-200 rounded"></div>
          <div className="h-3 w-full bg-gray-200 rounded"></div>
        </div>

      </div>
    </div>
  </div>
);

 // ✅ LOADING
if (loading) {
  return <AbandonedCartSkeleton />;
}

if (!cart) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center text-gray-500">
      <FiShoppingCart className="text-3xl mb-3 opacity-50" />
      
      <p className="text-sm font-medium">
        {t("No abandoned cart found","لم يتم العثور على سلة متروكة")}
      </p>

      <button
        onClick={() => navigate("/admin/abandoned-carts")}
        className="mt-4 px-4 py-2 bg-white border rounded-lg text-sm hover:bg-gray-50"
      >
        {t("Back to abandoned carts","العودة إلى السلات المتروكة")}
      </button>
    </div>
  );
}




const hasEmail = !!cart?.email;
const hasWhatsApp = !!cart?.phone;

const emailDone = !hasEmail || cart?.emailSent;
const whatsappDone = !hasWhatsApp || cart?.whatsappSent;

const allDone = emailDone && whatsappDone;


  return (
    <div className="flex bg-[#f1f1f1] min-h-screen">
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""}`}>
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-3 sm:p-5 animate-fadeSlide">
          <div className="max-w-[1040px] mx-auto">

{/* MOBILE HEADER */}
<div className="lg:hidden mb-3">

  {/* TOP ROW */}
  <div className="flex items-center justify-between">

    {/* LEFT */}
    <div className="flex items-center gap-2">

      <button
        onClick={() => navigate("/admin/abandoned-carts")}
        className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-200"
      >
        <div className="relative flex items-center justify-center w-6 h-6">
          <FiShoppingCart className="text-gray-900 text-[22px]" />
          <FiX className="absolute text-[12px] text-gray-900 mb-0.5 ml-1" />
        </div>
      </button>

      <div className="font-semibold text-[15px] text-[#202223]">
        #{cart.userId}
      </div>

    </div>

    {/* RIGHT STATUS DOT */}
    <div className="flex items-center gap-2">

      {!allDone && (
        <span className="w-2.5 h-2.5 rounded-full bg-yellow-500"></span>
      )}

      {allDone && (
        <span className="w-2.5 h-2.5 rounded-full bg-green-500"></span>
      )}

    </div>

  </div>

  {/* BADGES */}
  <div className="flex flex-wrap gap-2 mt-2">

    {cart.email && !cart.emailSent && (
      <span className="px-2 py-[2px] rounded-md text-[11px] bg-yellow-100 text-yellow-800">
        {t("Email","بريد")}
      </span>
    )}

    {cart.phone && !cart.whatsappSent && (
      <span className="px-2 py-[2px] rounded-md text-[11px] bg-yellow-100 text-yellow-800">
        {t("WhatsApp","واتساب")}
      </span>
    )}

  </div>

  {/* DATE */}
  <div className="mt-2 text-[12px] text-[#6d7175]">
    {(() => {
      const d = new Date(cart.created_at || Date.now());

      const date = d.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });

      const time = d.toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit",
      });

      return `${date} • ${time}`;
    })()}
  </div>

</div>

            {/* ================= HEADER (MATCH ORDER DETAILS) ================= */}
<div className="hidden lg:block mb-3">
  <div>

    {/* TOP ROW */}
    <div className="flex items-center gap-2">

      {/* BACK */}
      <button
        onClick={() => navigate("/admin/abandoned-carts")}
        className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-200"
      >
        <div className="relative flex items-center justify-center w-6 h-6">
          <FiShoppingCart className="text-gray-900 text-[22px]" />
          <FiX className="absolute text-[12px] text-gray-900 mb-0.5 ml-1" />
        </div>
      </button>

      {/* TITLE */}
      <div className="flex items-center gap-2">
        <FiChevronRight className="text-gray-400 text-[15px]" />

        <h1 className="text-[17px] font-semibold text-[#202223]">
          {t("Abandoned cart", "سلة متروكة")} #{cart.userId}
        </h1>

        {/* EMAIL BADGE */}
{cart.email && !cart.emailSent && (
  <span className="px-2.5 h-5 flex items-center rounded-md text-[11px] font-medium bg-yellow-100 text-yellow-800">
    {t("Email not sent", "البريد غير مرسل")}
  </span>
)}

{/* WHATSAPP BADGE */}
{cart.phone && !cart.whatsappSent && (
  <span className="px-2.5 h-5 flex items-center rounded-md text-[11px] font-medium bg-yellow-100 text-yellow-800">
    {t("WhatsApp not sent", "واتساب غير مرسل")}
  </span>
)}
      </div>
    </div>

    {/* DATE */}
    <div className="mt-1 text-[12px] text-[#6d7175] font-semibold">
  {(() => {
    const d = new Date(cart.created_at || Date.now());

    const date = d.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });

    const time = d.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
    });

    return lang === "AR"
  ? `${date} - ${time}`
  : `${date} at ${time}`;
  })()}
</div>

  </div>
</div>

            {/* ================= ROW 1 ================= */}
            <div className="mb-4">
              <div className="bg-white border border-[#e1e3e5] rounded-[18px] overflow-hidden">

 {/* ================= STATUS BANNER ================= */}
  {/* TOP MESSAGE */}
 <div
  className={`px-4 py-3 text-[14px] font-medium flex items-center gap-2 ${
    allDone
      ? "bg-green-100 text-black"
      : "bg-[#dbeafe] text-black"
  }`}
>
  {!allDone && <FiAlertTriangle className="text-[16px]" />}
  {allDone && <FiCheck className="text-[16px]" />}

  {allDone
    ? t(
        "Recovery message sent to customer",
        "تم إرسال رسالة الاسترجاع للعميل"
      )
    : t(
        "Contact your customer to recover their cart",
        "تواصل مع العميل لاسترجاع السلة"
      )}
</div>

  {/* BODY (ALWAYS VISIBLE) */}
  <div className="px-4 pt-3 pb-4">

    {/* LINK */}
    <div className="relative group">
  <div className="bg-[#f6f6f7] border border-[#d0d5dd] rounded-md px-3 py-2 pr-9 text-[13px] text-gray-900 break-all">
    {cart.cartLink}
  </div>

  {/* COPY ICON */}
  <button
    onClick={() => {
      navigator.clipboard.writeText(cart.cartLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }}
    className="absolute right-2 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition"
  >
    {copied ? (
      <FiCheck className="text-green-600 text-[16px]" />
    ) : (
      <FiCopy className="text-gray-500 text-[16px]" />
    )}
  </button>
</div>

    {/* ACTIONS */}
    <div className="flex gap-2 mt-3">

      <button
        onClick={handleSendEmail}
        disabled={!cart.email || sending === "email" || cart.emailSent}
        className="
px-4 h-[34px]
bg-white
border border-gray-300
rounded-md
text-sm
shadow-[0_1px_0_rgba(0,0,0,0.05)]
hover:bg-gray-50
active:translate-y-[1px]
disabled:bg-gray-100
disabled:text-gray-400
disabled:cursor-not-allowed
flex items-center gap-2
"
      >
        {sending === "email" ? (
  <span className="flex items-center gap-2">
    <span className="w-3 h-3 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></span>
    {t("Sending...", "جارٍ الإرسال...")}
  </span>
) : cart.emailSent ? (
  t("Email sent", "تم الإرسال")
) : (
  t("Send recovery email", "إرسال بريد الاسترجاع")
)}
      </button>

      <button
        onClick={handleSendWhatsApp}
        disabled={!cart.phone || cart.whatsappSent}
        className="
px-4 h-[34px]
bg-white
border border-gray-300
rounded-md
text-sm
shadow-[0_1px_0_rgba(0,0,0,0.05)]
hover:bg-gray-50
active:translate-y-[1px]
disabled:bg-gray-100
disabled:text-gray-400
disabled:cursor-not-allowed
flex items-center gap-2
"
      >
        {cart.whatsappSent
          ? t("WhatsApp sent", "تم الإرسال")
          : t("WhatsApp","واتساب")}
      </button>

    </div>

  </div>
</div>

            </div>

            {/* ================= ROW 2 ================= */}
            <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_320px] gap-3">

              {/* LEFT (70%) */}
<div className="bg-white border border-[#e1e3e5] rounded-[18px] overflow-hidden">

  {/* HEADER */}
  <div className="flex items-center justify-between px-4 pt-4 mt-1 ">
    <h2 className="text-[13px] font-semibold text-[#202223]">
      {t("Checkout details", "تفاصيل الدفع")}
    </h2>

    <span className="text-[12px] text-[#6d7175] font-medium">
      {t("From Online Store", "من المتجر الإلكتروني")}
    </span>
  </div>

  {/* PRODUCTS TABLE */}
  <div className="p-4">
    <div className="border border-[#e1e3e5] rounded-[14px] overflow-hidden">

      {cart.cartItems.map((it, i) => (
        <div
          key={i}
          className="grid grid-cols-[minmax(0,1fr)_140px_120px] items-center px-4 py-3 border-b last:border-b-0 border-[#f1f2f3]"
        >

          {/* PRODUCT */}
          <div className="flex items-center gap-3 min-w-0">

            <div className="w-10 h-10 rounded-lg overflow-hidden bg-[#f6f6f7] border border-[#e1e3e5]">
              {it.image && (
                <img src={it.image} alt="" className="w-full h-full object-cover" />
              )}
            </div>

            <div className="min-w-0">
              <div className="text-sm font-medium text-[#202223] truncate">
                {lang === "AR" ? it.name_ar || it.name_en : it.name_en}
              </div>
            </div>

          </div>

          {/* UNIT */}
          <div className="text-center text-sm text-[#6d7175]">
            {it.qty} × ${Number(it.price).toFixed(2)}
          </div>

          {/* TOTAL */}
          <div className="text-right text-sm font-medium text-[#202223]">
            ${(it.qty * it.price).toFixed(2)}
          </div>

        </div>
      ))}

    </div>

    {/* SUMMARY */}
    <div className="mt-4 rounded-[14px] overflow-hidden text-[14px]">

      {/* SUBTOTAL */}
      <div className="grid grid-cols-[1fr_1fr_120px] px-4 py-3">
        <span className="text-[#202223] font-medium">
          {t("Subtotal","المجموع الفرعي")}
        </span>

        <span className="text-center text-[#6d7175]">
          {cart.cartItems.reduce((s,i)=>s+i.qty,0)} {t("items","قطعة")}
        </span>

        <span className="text-right font-medium">
          ${total.toFixed(2)}
        </span>
      </div>

      {/* SHIPPING */}
      <div className="grid grid-cols-[1fr_1fr_120px] px-4 py-3">
        <span>{t("Shipping fees","رسوم الشحن")}</span>
        <span></span>
        <span className="text-right">
  ${shippingFee.toFixed(2)}
</span>
      </div>

      {/* TOTAL */}
      <div className="grid grid-cols-[1fr_1fr_120px] px-4 py-3 font-semibold">
        <span>{t("Total","الإجمالي")}</span>
        <span></span>
        <span className="text-right">
          ${(total + shippingFee).toFixed(2)}
        </span>
      </div>

      {/* LINE */}
      <div className="border-t border-[#e1e3e5]" />

      {/* TO PAY */}
      <div className="grid grid-cols-[1fr_1fr_120px] px-4 pt-3 pb-1">
        <span>{t("To be paid by customer","المبلغ المطلوب من العميل")}</span>
        <span></span>
        <span className="text-right font-medium">
          ${(total + shippingFee).toFixed(2)}
        </span>
      </div>

    </div>

  </div>
</div>

              {/* RIGHT (30%) */}
             <div className="bg-white border border-[#e1e3e5] rounded-[18px] overflow-hidden">

<div className="p-4">

  <h2 className="text-[13px] font-semibold text-[#202223] mb-4">
    {t("Customer","العميل")}
  </h2>

  {/* NAME */}
  <div>
  <div className="text-sm font-semibold text-[#202223]">
    {cart.name || t("Guest","زائر")}
  </div>

  <div className="text-[12px] text-[#6d7175] mt-[2px]">
    {cart.ordersCount || 0} {t("orders", "طلبات")}
  </div>
</div>

  {/* CONTACT */}
  <div className="mt-3">
    <div className="text-[13px] font-semibold text-[#202223] mb-1">
      {t("Contact information","معلومات التواصل")}
    </div>

    {cart.email && (
      <div className="text-sm text-[#1a73e8]">
        {cart.email}
      </div>
    )}

    <div className="text-sm text-[#202223]">
      {cart.phone || t("Not available","غير متوفر")}
    </div>
  </div>

  {/* ADDRESS */}
  <div className="mt-4">
    <div className="text-[13px] font-semibold text-[#202223] mb-1">
      {t("Shipping address","عنوان الشحن")}
    </div>

    <div className="text-sm text-[#202223] leading-relaxed">
      {cart.name || t("Guest","زائر")}<br/>
      {cart.area || "—"}<br/>
      {cart.street || "—"}<br/>
      {cart.city || "—"}<br/>
      {cart.building || "—"}
    </div>
  </div>

{/* MARKETING */}
<div className="mt-4">
  <div className="text-[13px] font-semibold text-[#202223] mb-2">
    {t("Marketing", "التسويق")}
  </div>

  <div className="flex gap-2 flex-wrap">
    {cart.email && (
  <div
    className={`flex items-center gap-1 px-2.5 h-6 rounded-md text-[11px] font-medium border
    ${
      cart.emailSent
        ? "bg-green-100 text-green-700 border-green-200"
        : "bg-gray-100 text-gray-600 border-gray-200"
    }`}
  >
    {!cart.emailSent ? (
      <span className="w-2 h-2 border border-gray-400 rounded-[3px]" />
    ) : (
      <FiCheck className="text-[12px]" />
    )}

    {t("Email","بريد")}
  </div>
)}
{cart.phone && (
  <div
    className={`flex items-center gap-1 px-2.5 h-6 rounded-md text-[11px] font-medium border
    ${
      cart.whatsappSent
        ? "bg-green-100 text-green-700 border-green-200"
        : "bg-gray-100 text-gray-600 border-gray-200"
    }`}
  >
    {!cart.whatsappSent ? (
      <span className="w-2 h-2 border border-gray-400 rounded-[3px]" />
    ) : (
      <FiCheck className="text-[12px]" />
    )}
    {t("WhatsApp","واتساب")}
  </div>
)}
  </div>
</div>
</div>

</div>

            </div>

          </div>
        </main>
      </div>
    </div>
  );
}

export default AdminAbandonedCartDetails;